<template>
  <GenericModal
    modal-open-trigger-handler-id="BOXNOW_WidgetOpen"
    modal-close-trigger-handler-id="BOXNOW_WidgetClose"
    ref="BOXNOW_WidgetModal"
    :unique-id="'BOXNOW_WidgetModal'"
  >
    <div class="box-now-map-widget-container">
      <a ref="widgetElementOpenButton" href="javascript:void(0)" class="boxnow-map-widget-button"></a>
      <div v-show="getSelectedTransporterObject && getSelectedTransporterObject.class_name === 'BOXNOW'" id="boxnowmap"></div>
    </div>

    <input type="hidden" name="smartPointJsonData" :value="JSON.stringify(getSelectedSmartPoint)">

  </GenericModal>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '../../../../vue/store'
import GenericModal from '../../presentation/GenericModal'
import SmartPointModelDTO from '../SmartPointModelDTO'

export default {
  name: 'BoxNowWidget',
  components: {
    GenericModal
  },
  created () {
    this.$root.$on('BOXNOW_AfterSelect', (payload) => {
      const smartPoint = new SmartPointModelDTO(
        payload.boxnowLockerId,
        payload.boxnowLockerName,
        payload.boxnowLockerAddressLine1 + ' ' + payload.boxnowLockerAddressLine2,
        '',
        payload.boxnowLockerLat,
        payload.boxnowLockerLng,
        payload.boxnowLockerPostalCode
      )
      store.dispatch('setSelectedSmartPoint', smartPoint).then(() => {
        this.$root.$emit('BOXNOW_WidgetClose')
      }).finally(() => {
        this.$toasted.success(
          this.t('pickup.point.selected'), { duration: '2500' }
        )
      })
    })
    this.$root.$on('BOXNOW_WidgetOpen', this.clickOpenWidgetElement)
  },
  destroyed () {
    this.$root.$off('BOXNOW_AfterSelect')
    this.$root.$off('BOXNOW_WidgetOpen')
  },
  computed: {
    ...mapGetters([
      'getSelectedSmartPoint',
      'getSelectedTransporterObject'
    ])
  },
  methods: {
    addSelectedData (payload) {
      this.$set(this, 'selectedData', payload)
    },
    clickOpenWidgetElement () {
      if (this.$refs.widgetElementOpenButton) {
        this.$refs.widgetElementOpenButton.click()
      }
    }
  }
}
</script>

<style lang="scss">
  #boxnowmap {
    iframe {
      z-index: 999999;
      top: 0;
      left: 0;
      display: flex;
      min-height: 100%;
      position: absolute;
    }
  }
  .boxnow-map-widget-button {
    display: none;
  }
</style>
